import {Injectable} from "@angular/core";
import {RxStomp,RxStompState} from "@stomp/rx-stomp";
import {HttpClient} from "@angular/common/http";
import {Observable,takeWhile} from "rxjs";
import {environment} from "@environments/environment";
import {first} from "rxjs/operators";
import {stompConfig} from "@share/websocketServiceFactory";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";

/**
 * Service permettant de se connecter à la websocket
 */
@Injectable({
	providedIn: 'root'
})
export class WebsocketService extends RxStomp {
	/** Flag permettant de différencier une clôture manuelle ou non de la websocket */
	private isClosedManually = false;

	/**
	 * Constructeur
	 *
	 * @param http client HTTP
	 * @param toastrService Service de notification
	 * @param translateService Service de traduction
	 */
	constructor(private http: HttpClient,private toastrService: ToastrService,private translateService: TranslateService) {
		super();
	}

	/**
	 * Déconnexion websocket.
	 */
	deactivate(options?: { force?: boolean }): Promise<void> {
		//Fermeture explicite
		this.isClosedManually = true;

		//Retour de la promesse originale
		return super.deactivate(options);
	}

	/**
	 * Connexion websocket.
	 */
	activate() {
		//Initialisation
		this.isClosedManually = false;

		//Récupération du token CSRF
		this.getCsrfToken().subscribe(csrf => {
			let reconnectCount = 0;

			//Ajout du token dans le header STOMP de connexion
			stompConfig.connectHeaders = {'X-CSRF-TOKEN': csrf};

			//Modification de la configuration pour prendre en compte le nouveau header
			this.configure(stompConfig);

			//Connexion Websocket
			super.activate();

			//Gestion de la reconnexion automatique avec abandon suivant le nombre de tentatives atteint
			//Désabonnement automatique en cas de fermerture de la websocket ou d'une dem
			this.connectionState$.pipe(takeWhile(value => this.active && !this.isClosedManually)).subscribe(state => {
				//Vérification du statut de la connexion
				if (state === RxStompState.CLOSED) {
					//Incrémentation du nombre de reconnexions
					reconnectCount++;

					//Log (debug)
					console.debug(`Tentative de reconnexion #${reconnectCount}`);

					//Si le nombre maximum de tentatives de reconnexions est atteint
					if (reconnectCount >= stompConfig.reconnectMax) {
						//Fermeture de la websocket
						this.deactivate();

						//Message
						this.toastrService.error(this.translateService.instant('global.errors.connexionPerdue'));

						//Log (debug)
						console.debug('Nombre maximum de tentatives atteint. Reconnexion arrêtée.');
					}
				} else if (state === RxStompState.OPEN) {
					//Ré-initialisation du compteur de tentatives de reconnexions
					reconnectCount = 0;
				}
			});
		});
	}

	/**
	 * Récupération du token CSRF.
	 */
	getCsrfToken(): Observable<string> {
		return this.http.get<string>(`${environment.baseUrl}/websocket/csrf`).pipe(first());
	}

}
